
import RfkitsFinder from '../class/RfkitsFinder';
import SupportedVehicles from '../class/SupportedVehicles';
import LazyloadImg from '../class/LazyloadImg';
import Tooltip from '../class/Tooltip';
import Guide2 from "../class/Guide2";
import {OffCanvaMenu} from "../class/OffCanvaMenu";
import {SuperAlign} from "../class/SuperAlign";
require('select2');

$(function(){

  //INITS
  $(".js-select2").on('change', function(){
    $('.product-card').each(function(){
        var hide = false;
        if($(this).attr('data-communication') != $('#js-guides-communication').val() && $('#js-guides-communication').val().length > 0){
          hide = true;
        }
        if(parseInt($(this).attr('data-range')) <= parseInt($('#js-guides-range').val())){
          hide = true;
        }
        if($(this).attr('data-brand') != $('#js-guides-brand').val() && $('#js-guides-brand').val().length > 0){
          hide = true;
        }

        if(hide){
          $(this).parent().addClass('d-none');
        }else{
          $(this).parent().removeClass('d-none');
        }
    });

    if($(".product-wrapper.d-none").length === $(".product-wrapper").length) {
      $('.no-results').addClass('show');
    } else {
      $('.no-results').removeClass('show');
    }

  }).trigger('change');
});


const superAlign = new SuperAlign('.js-text-normalize');
superAlign.init();

new OffCanvaMenu('.js-menu-overlay-container',
  function (){
    superAlign.initNormalization();
  },
  function(){
    $("#js-guides-brand").val('851').trigger('change');
    superAlign.initNormalization();
  }
).init();

const installGuides = new Guide2('.js-guides-install');
installGuides.init();

const userGuides = new Guide2('.js-guides-user');
userGuides.init();



//new RfkitsFinder('.js-rfkit-selector', '.js-rfkits-list', '.js-rfkits-item', '.msg').init();
new SupportedVehicles('data-makeid', '.wrapper-table-supported', '.js-technology-id', '/ajax/supported_technology_vehicles.php').init();
new LazyloadImg('.lazy-load-img', 'data-listener-lazy-id', 'data-img-id').init()
new Tooltip('.tooltip-custom', '/ajax/feature_benefits.php').init();


